export const borders = {
  _1px: '1px',
  _1_5px: '1.5px',
  _thin: 'thin',
  _0_5px: '0.5px',
  default: '1px solid currentColor',
  half: '0.5px solid currentColor',
  thin: 'thin solid currentColor',
  thin_0_3: '0.3px solid currentColor',
  dash_0_3: '0.3px dashed currentColor',
  getSolid: (color: string, width: string) => `${width} solid ${color}`,
  getDash: (color: string, width: string) => `${width} dashed ${color}`
};

export const transitions = {
  transform: 'transform 0.3s ease',
  translate: 'translate 0.3s ease',
  width: 'width 0.5s ease',
  height: 'height 0.5s ease',
  height_0_3: 'height 0.3s ease',
  width_0_3: 'width 0.3s ease',
  opacity_0_5: 'opacity 0.5s ease',
  opacity_0_3: 'opacity 0.3s ease',
  margin: 'margin 0.5s ease',
  borderRadius: 'border-radius 0.3s ease',
  opacity: 'opacity 0.3s ease',
  inset: 'inset 0.5s ease',
  defaultDuration: 500,
  compose: (...parts: string[]) => parts.join(', ')
};

export const transforms = {
  mirrorY: (mirror: boolean) => `scaleY(${mirror ? -1 : 1})`,
  mirrorX: (mirror: boolean) => `scaleX(${mirror ? -1 : 1})`,
  shiftX: (amount: number, mirror?: boolean, unit: '%' | 'px' = 'px') =>
    `translateX(${mirror ? -amount : amount}${unit})`,
  shiftY: (amount: number, mirror?: boolean, unit: '%' | 'px' = 'px') =>
    `translateY(${mirror ? -amount : amount}${unit})`,
  shift50X: (mirror: boolean) => `translateX(${mirror ? -50 : 50}%)`,
  shift50Y: (mirror: boolean) => `translateY(${mirror ? -50 : 50}%)`,
  scale110XY: 'scale(1.1)',
  scale100X: 'scaleX(1)',
  rotate45: 'rotate(45deg)',
  rotate90: 'rotate(90deg)',
  rotateMinus90: 'rotate(-90deg)',
  rotateNone: 'rotate(0deg)',
  scaleMirrored: '-1',
  scaleDefault: '1',
  compose: (...parts: (string | undefined | null | boolean)[]) => parts.filter(Boolean).join(' ')
};

export const blur = {
  default: 'blur(5px)'
};

export const navbar = {
  defaultFullWidth: 200,
  collapsedWidth: 72
};

export const NAVBAR_FULL_WIDTH_CSS_VAR = '--navbar-full-width';
